var map = {
	"./arrow-btn.svg": 6661,
	"./calendar.svg": 681,
	"./card.svg": 3473,
	"./check.svg": 7121,
	"./cloud.svg": 3822,
	"./copy.svg": 9384,
	"./copyright.svg": 5542,
	"./flag-ar.svg": 2667,
	"./flag-de.svg": 8575,
	"./flag-en.svg": 6155,
	"./flag-es.svg": 1518,
	"./flag-fr.svg": 9014,
	"./flag-pt.svg": 7522,
	"./flag-ru.svg": 6781,
	"./flag-tr.svg": 5936,
	"./flag-usa.svg": 5571,
	"./how-1.svg": 5837,
	"./how-2.svg": 2862,
	"./how-3.svg": 9884,
	"./how-4.svg": 32,
	"./how-5.svg": 4417,
	"./how-6.svg": 7314,
	"./icq.svg": 2432,
	"./info.svg": 5923,
	"./mail.svg": 7686,
	"./skype.svg": 9995,
	"./telegram.svg": 3774,
	"./tg.svg": 4248,
	"./theme-1.svg": 1088,
	"./theme-2.svg": 5635,
	"./theme-3.svg": 2994,
	"./theme-4.svg": 7661,
	"./theme-5.svg": 7948,
	"./theme-6.svg": 3295,
	"./theme-7.svg": 8542,
	"./theme-8.svg": 5273,
	"./up.svg": 852,
	"./user.svg": 6602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9945;